/*
 * @Author: 江舟
 * @Date: 2023-04-06 15:41:17
 * @LastEditors: 江舟
 * @LastEditTime: 2023-04-13 17:23:49
 * @FilePath: \Gov-Web\Mobile\src\service\modules\complaintApis\modules\leader.js
 * @Description: file content
 */
import $http from '../http';
let complaintPath = '/tio/complain/v2/api/';
// 按时间维度统计投诉数量
export const getCountByTime = data => {
  return $http({
      url: complaintPath + 'newWorkbench/workbench/complainTime',
      data,
      method: 'POST'
  });
};
// 落点分布统计
export const getCountByPlace = data => {
  return $http({
      url: complaintPath + 'newWorkbench/workbench/dropDistribution',
      data,
      method: 'POST'
  });
};

// 投诉处理情况统计
export const getCountByAllStatus = data => {
  return $http({
      url: complaintPath + 'newWorkbench/workbench/handling',
      data,
      method: 'POST'
  });
};

/**
 * 投诉处理情况统计
 * @param {*} data 
 * @returns
 * @wiki https://www.tapd.cn/67427372/markdown_wikis/show/#1167427372001007464
 */
export const getAppMetricsCount = data => {
  return $http({
      url: complaintPath + 'workbench/getAppMetricsCount',
      data,
      method: 'GET'
  });
};


// 投诉处理状况详情数据
export const getComplainStateDetail = data => {
  return $http({
      url: complaintPath + 'newWorkbench/workbench/complainState',
      data,
      method: 'POST'
  });
};
// 投诉处理状态落点分布
export const getNotCompletePoint = data => {
  return $http({
      url: complaintPath + 'newWorkbench/workbench/notCompletePoint',
      data,
      method: 'POST'
  });
};

export default {
  getCountByTime,
  getCountByPlace,
  getCountByAllStatus,
  getAppMetricsCount,
  getComplainStateDetail,
  getNotCompletePoint
};
